// extracted by mini-css-extract-plugin
export var circle = "_4d-2";
export var icon = "_4d-a";
export var iconHighlight = "_4d-0";
export var lg = "_4d-8";
export var md = "_4d-7";
export var outline = "_4d-4";
export var sm = "_4d-6";
export var square = "_4d-1";
export var xl = "_4d-9";
export var xs = "_4d-5";
export var xxs = "_4d-3";